import {gql} from "apollo-angular";
import {basePageableGraphqlField, baseResponseGraphqlField} from "../../../base.graphql";
import {citizenServicesFieldFew} from "../citizens-services/citizens-services.graphql";

export const requestedServiceFields = `
data {
      requests
      delivered
      pending
      overdue
    }
    response {
      id
      status
      code
      message
    }
`

export const GET_MY_REQUESTED_SERVICES = gql`
  query GetMyServiceRequestsStats {
    getMyServiceRequestsStats {
      response {
        status
        id
        code
        message
      }
      data {
        delivered
        requests
        pending
        overdue
      }
    }
  }`

